import crypto from 'crypto';

export const getSubscriberKeyFromEmail = (
  email: string,
): { email: string; subscriberKey: string } | false => {
  if (!email) return false;

  // Convert email to lowercase for consistency
  const normalizedEmail = email.toLowerCase().trim();

  // Create MD5 hash
  const md5HashedEmail = crypto
    .createHash('md5')
    .update(normalizedEmail)
    .digest('hex')
    .toUpperCase();

  return {
    email: normalizedEmail,
    subscriberKey: md5HashedEmail,
  };
};
